import { Caption, Typography } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { LabelWithCheck } from '@/components/LabelWithCheck'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'

import HouseRent from '../Icon/HouseRent'

import { houseRentIcon } from './styles.css'

type Props = {
  property: ListingCate
}

const FormInfoThirdParty: React.FC<Props> = ({ property }) => {
  const { t } = useTranslation()

  return (
    <div
      className={sprinkles({
        display: 'flex',
        gap: 'm',
        justifyContent: 'space-around',
        marginBottom: '2xl',
        paddingX: '5xl',
      })}
    >
      <div className={sprinkles({ flex: 1 })}>
        <Typography
          className={sprinkles({
            paddingBottom: 's',
          })}
          variant="bodyM"
        >
          <HouseRent className={houseRentIcon} />
          <strong>{property.contactInfo.agencyName}</strong>
        </Typography>

        <Caption color="greyscale500">{property.contactInfo.agencyAddress}</Caption>
      </div>
      <div className={sprinkles({ flex: 1 })}>
        <LabelWithCheck>{t('listing-detail:form-header.agency.one')}</LabelWithCheck>
        <LabelWithCheck>{t('listing-detail:form-header.agency.two')}</LabelWithCheck>
      </div>
    </div>
  )
}

export default FormInfoThirdParty
